import React from "react";
import {
	BsInfoCircle,
} from "react-icons/bs";
import DateUtils from "../../../../shared/utils/DateUtils";
import MonetaryUtils from "../../../../shared/utils/MonetaryUtils";
import TooltipGeneric from "../../../../shared/components/generic/tooltip/tooltip-generic";
import IconAction from "../../../../shared/components/generic/button/icon-action/icon-action";

const netSalesTooltipText = `O intervalo de cada faixa de Net Sales está entre o valor cadastrado nela e o valor inicial da próxima faixa. Ex:
		TAMANHO | NET SALES
		A | R$1.000
		B | R$2.000
	A faixa A vai de R$1.000 a R$1.999.
	Se a faixa B muda para R$2.500, a faixa A passa a estar entre R$1.000 e R$2.499.`;

export const segmentationColumnsConfig = ({
	onEdit,
	onDelete
}) => [
	{
		key: "segmentation",
		label: "Tamanho do Cliente",
		width: "20%",
		render: row => row.segmentation || "-"
	},
	{
		key: "netSalesGreaterThanOrEqual",
		label: (
			<span className="admin-table-header-tooltip">
				<span>Net Sales Maior ou Igual a</span>

				<TooltipGeneric
					content={netSalesTooltipText}
					ariaLabel="Explicação sobre faixas de Net Sales"
				/>
			</span>
		),
		width: "20%",
		render: row => MonetaryUtils.formatCurrency(row.netSalesGreaterThanOrEqual) || "-"
	},
	{
		key: "createdAt",
		label: "Data de criação",
		width: "20%",
		render: row => DateUtils.formatDateToBrazilian(row.createdAt)
	},
	{
		key: "updatedAt",
		label: "Data da Última Atualização",
		width: "20%",
		render: row => DateUtils.formatDateToBrazilian(row.updatedAt)
	},
	{
		key: "actions",
		label: "Ações",
		width: "20%",
		render: row => (
            <IconAction
                row={row}
                actions={[
                    {
                        key: "edit",
                        variant: "edit",
                        title: "Editar",
                        onClick: onEdit
                    },
                    {
                        key: "delete",
                        variant: "delete",
                        title: "Excluir",
                        onClick: onDelete
                    }
                ]}
            />
        )
	}
];